import { z } from "zod";
import { MemberStatus } from "../enum.js";

const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const listMembersQuerySchema = z
	.object({
		page: z.coerce.number().int().min(1).default(1),
		limit: z.coerce.number().int().min(1).max(50).default(10),
		search: z.string().optional(),
		group_ids: z
			.string()
			.refine((val) => val.split(",").every((id) => uuidPattern.test(id.trim())), {
				message: "group_ids must be comma-separated UUIDs",
			})
			.optional(),
		status: z.enum(MemberStatus).optional(),
		include_invited: z
			.union([z.literal("true"), z.literal("false"), z.boolean()])
			.transform((value) => value === true || value === "true")
			.optional(),
	})
	.strict();

export type ListMembersQueryPayload = z.infer<typeof listMembersQuerySchema>;
